import CommunityTab from '@/components/health/CommunityTab';

import { AppPage } from '../../ui-foundation';

export default function CommunityPage() {
  return (
    <AppPage>
      <CommunityTab />
    </AppPage>
  );
}
